import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import Table from "./projects/Table/Table";


if (document.querySelector("main.projects")) {

    document.documentElement.classList.add('pourcent')

    const root = createRoot(document.getElementById("react-root"));
    const data = JSON.parse( document.querySelector("[data-projects]").getAttribute('data-projects') );

    const searchValueInit = document.querySelector('[data-search]') ? document.querySelector("[data-search]").getAttribute('data-search') : null;

    root.render(
        <>
            <Table data={data} searchValueInit={searchValueInit}/>
        </>
    );

}
const ke = new KeyboardEvent('keydown', {
    bubbles: true, cancelable: true, keyCode: 13
});